/** Shared mobile bottom navigation route and layout constants. */

export const MOBILE_BOTTOM_NAV_HEIGHT_PX = 56;
/** Above the assist overlay and the floating bar, below MUI modal (1300). */
export const MOBILE_BOTTOM_NAV_Z = 1250;
/** Below the bottom nav so the chat composer cannot cover or steal taps from the tabs. */
export const MOBILE_CHATBOT_OVERLAY_Z = 1200;
/** Floating homepage prompt. Below the tab bar so a stale copy cannot cover the tabs. */
export const MOBILE_FLOATING_ASSIST_Z = 1240;

export const HOMEPAGE_ROUTES = new Set(['/', '/flights', '/hotels', '/trains']);

/** Routes that show the primary four-tab mobile bottom navigation bar. */
export const PRIMARY_MOBILE_NAV_ROUTES = new Set([
  ...HOMEPAGE_ROUTES,
  '/my-trips',
  '/account',
]);

export const MOBILE_NAV_PORTAL_SELECTOR =
  '[data-yovo-mobile-assist-bar], [data-yovo-mobile-bottom-nav]';

/** Fixed offset for content/overlay spacing above the bottom nav strip. */
export const MOBILE_BOTTOM_NAV_OFFSET =
  `calc(${MOBILE_BOTTOM_NAV_HEIGHT_PX}px + env(safe-area-inset-bottom, 0px))`;

/** Homepage-only floating assist bar sits above the bottom nav. */
export const MOBILE_FLOATING_ASSIST_OFFSET = MOBILE_BOTTOM_NAV_OFFSET;

export function normalizePathname(pathname) {
  return (pathname || '/').replace(/\/+$/, '') || '/';
}

export function isHomepageRoute(pathname) {
  return HOMEPAGE_ROUTES.has(normalizePathname(pathname));
}

export function isPrimaryMobileNavRoute(pathname) {
  return PRIMARY_MOBILE_NAV_ROUTES.has(normalizePathname(pathname));
}

/**
 * Derive the active bottom-nav tab from the current route.
 * Assist overlay state is passed in separately (not a route).
 */
export function getMobileNavActiveTab(pathname, { assistActive = false } = {}) {
  if (assistActive) return 'assist';

  const path = normalizePathname(pathname);

  if (path === '/my-trips') return 'my-trips';
  if (path === '/account') return 'profile';
  if (HOMEPAGE_ROUTES.has(path)) return 'home';

  return null;
}
